/* eslint-disable jsx-a11y/aria-proptypes */
/* eslint-disable prettier/prettier */
'use client';
import LinkWrapper from 'helpers/SitecoreWrappers/LinkWrapper/LinkWrapper';
import { JSX, useRef } from 'react';
import { tv } from 'tailwind-variants';

const SkipToMainContentBar = (): JSX.Element => {
  const { linkWrapperClass, linkTextClass } = TailwindVariants();
  const linkRef = useRef<HTMLAnchorElement>(null);

  const handleClick = () => {
    if (typeof document !== undefined) {
      const mainContent = document.querySelector('#mainContent');
      if (mainContent && 'focus' in mainContent) {
        (mainContent as HTMLElement).focus();
      }
    }
  };

  const onEnterKeyDown = (e: React.KeyboardEvent<HTMLAnchorElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      handleClick();
    }
  };

  return (
    <>
      <LinkWrapper
        tabIndex={0}
        ref={linkRef}
        field={{
          href: '#mainContent',
          title: 'Skip to main content',
          text: 'Skip to main content',
          target: '_self',
        }}
        className={linkWrapperClass()}
        aria-label="Skip to main content"
        onClick={handleClick}
        onKeyDown={(e) => onEnterKeyDown(e)}
      >
        <span className={linkTextClass()}>Skip to main content</span>
      </LinkWrapper>
    </>
  );
};

export default SkipToMainContentBar;

export const TailwindVariants = tv({
  slots: {
    linkWrapperClass:
      'font-centuryGothic text-[17px] font-bold focus:outline focus:outline-white underline absolute -top-full left-0 z-50 w-full transition-transform duration-200 translate-y-0 focus:sticky bg-blue-700 text-white py-4 lg:px-0 px-10 !h-[48px] flex items-center justify-center',
    linkTextClass: 'w-full max-w-[1280px] block text-left px-4 lg:px-0',
  },
});
